module.exports = __webpack_public_path__ + "static/img/2017122016334095.d3e5579.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2017122016334095.jpg
// module id = VfAY
// module chunks = 0